import { render, staticRenderFns } from "./Lesson3.vue?vue&type=template&id=3cec4efa&scoped=true&"
import script from "./Lesson3.vue?vue&type=script&lang=js&"
export * from "./Lesson3.vue?vue&type=script&lang=js&"
import style0 from "./Lesson3.vue?vue&type=style&index=0&id=3cec4efa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cec4efa",
  null
  
)

export default component.exports